import React, { useRef } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import heroDesktop from '../../assets/video/heroD.mp4';
import heroMobile from '../../assets/video/heroM.mp4';
import './Hero.css';
import { AiFillPlayCircle } from 'react-icons/ai';
import { MdPauseCircle } from 'react-icons/md';
import { BsFillVolumeMuteFill } from 'react-icons/bs';
import { GoUnmute } from 'react-icons/go';
import $ from 'jquery';
const Hero = () => {
  const [show, setShow] = useState(true);

  const [paly, setPlay] = useState(true);
  const [mute, setMute] = useState(true);
  const myvideo = useRef();
  const [video, setVideo] = useState(
    window.innerWidth > 425 ? heroDesktop : heroMobile
  );

  const handlePlay = () => {
    myvideo.current.play();
    setPlay(true);
  };

  const handlePause = () => {
    myvideo.current.pause();
    setPlay(false);
  };
  const handleMute = () => {
    myvideo.current.muted = true;
    setMute(true);
  };

  const handleUnmute = () => {
    myvideo.current.muted = false;
    setMute(false);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    function chechSize(e) {
      if (window.innerWidth > 425) {
        setVideo(heroDesktop);
      } else {
        setVideo(heroMobile);
      }
    }

    window.addEventListener('resize', chechSize);
  });

  return (
    <div className=" w-full h-fit relative flex flex-col overflow-x-hideen overflow-hidden">
      <div className=" xxs:w-full xxs:h-screen  flex flex-col">
        <video
          autoPlay
          loop
          ref={myvideo}
          muted
          className=" w-full h-full object-cover "
        >
          <source src={video} type="video/mp4" />
        </video>
      </div>
      <div className=" w-full h-full absolute z-20  justify-start items-start ">
        <div
          className={`menu  blur-3xl  opacity-0
           
          }    relative    top-16  left-0 cursor-pointer  w-[600px] h-[800px]`}
          onMouseEnter={() => {
            setShow(true);
          }}
          onMouseLeave={() => {
            setShow(false);
          }}
        >
          <div
            className={` ${
              show ? 'z-10' : '-z-10 '
            }  w-full h-full  xxs:flex xxs:justify-start xxs:items-center xxs:-mt-4 relative text-white font-[900] xxs:left-7 sm:left-0 font-child px-7 xxs:text-[50px] sm:text-[65px] md:text-[100px] sm:justify-start sm:items-start tracking-tighter leading-tight`}
          >
            <ul className="">
              <li className="  ">
                <Link to="/story">
                  <img
                    src={require('../../assets/images/bs.png')}
                    alt="bt"
                    className=" h-[150px]  "
                  />
                </Link>
              </li>
              <li className=" ">
                <Link to="/join">
                  <img
                    src={require('../../assets/images/bj.png')}
                    alt="bt"
                    className="  h-[150px] relative -top-10 "
                  />
                </Link>
              </li>
              <li className=" ">
                <Link to="/mint">
                  <img
                    src={require('../../assets/images/bm.png')}
                    alt="bt"
                    className="  h-[150px]  relative -top-14 "
                  />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="   w-full h-full absolute top-0 right-0 px-7 py-7 flex flex-col justify-start  items-end  text-3xl text-white">
        <div className="  relative cursor-pointerw-fit">
          {paly ? (
            <MdPauseCircle
              onClick={handlePause}
              className=" z-40 relative cursor-pointer opacity-30"
            />
          ) : (
            <AiFillPlayCircle
              onClick={handlePlay}
              className=" z-40 relative cursor-pointer opacity-30"
            />
          )}
        </div>
        <div className=" cursor-pointer w-fit mt-4">
          {mute ? (
            <GoUnmute
              onClick={handleUnmute}
              className=" z-40 relative cursor-pointer opacity-30"
            />
          ) : (
            <BsFillVolumeMuteFill
              onClick={handleMute}
              className=" z-40 relative cursor-pointer  opacity-30"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Hero;
